import { useState } from "react";

import { parseValue } from "../../../../../../ui library/helpers/functions";
import { moduleProps as modulePropOverrides } from "../helpers/propNameHelper";

import { FieldModule } from "./FieldModule";

export function ModulePrimitiveForm({
  schema,
  data,
  label,
  questionKey,
  handleAnswerChange,
  placeholder,
  subTitle,
  footer,
  readOnly,
}) {
  const isFlatSchema = schema?.type && !schema?.expected_input;

  const [form, setForm] = useState(() => (isFlatSchema ? { field: data } : { ...data }));
  const [err, setErr] = useState({});

  const expectedInput = schema?.expected_input;
  const selectedSchema = schema[expectedInput];
  const properties = isFlatSchema ? { field: schema } : selectedSchema?.properties;
  const requiredFields = isFlatSchema ? [] : selectedSchema?.required ?? [];

  const fields = Object.keys(properties || {}).filter((name) => name !== "id");
  const onChange = (field, value) => {
    const fieldSchema = properties?.[field];
    const type = fieldSchema?.type;
    const parsedValue = parseValue(value, type);
    const updated = { ...form, [field]: parsedValue };
    setForm(updated);
    setErr((e) => ({ ...e, [field]: undefined }));

    const resultToSend = isFlatSchema ? parsedValue : updated;
    handleAnswerChange(questionKey, resultToSend);
  };

  return (
    <div className="grid grid-cols-1 items-end gap-4 md:grid-cols-12">
      {fields.map((name, idx) => {
        const prop = { ...properties[name], ...(modulePropOverrides?.[name] ?? {}) };
        const isSingleQuestion = isFlatSchema || fields?.length === 1;
        const labelToRender = isSingleQuestion ? label : prop?.title || "";
        const fallbackSpan =
          isSingleQuestion ? "md:col-span-12" : idx % 2 === 0 ? "md:col-span-5" : "md:col-span-7";
        const spanClass = fallbackSpan;
        const isRequired = properties[name]?.required ?? false;

        return (
          <div key={name} className={`${spanClass} min-w-0`}>
            <FieldModule
              label={labelToRender}
              name={name}
              prop={prop}
              value={form[name]}
              formValues={form}
              onChange={onChange}
              enumUrl={typeof prop?.enum === "string" ? prop.enum : undefined}
              placeholder={placeholder}
              subTitle={subTitle}
              footer={footer}
              readOnly={readOnly}
              isRequired={isRequired}
            />
            {err[name] && <p className="mt-1 text-sm text-red-600">{err[name]}</p>}
          </div>
        );
      })}
    </div>
  );
}
